import $ from 'jquery';

export default function() {
  function getScope($el) {
    const $scope = $el.closest('[id^="shopify-section-"]');
    return $scope.length ? $scope : $(document);
  }

  function filterFAQs(search_q, $scope) {
    const query = (search_q || '').toLowerCase().trim();
    const searchTerms = query.length ? query.split(/\s+/).filter(Boolean) : [];

    if (!query) {
      const $accordions = $scope.find('[data-accordion]');
      $accordions.removeAttr('data--hidden').show();
      $accordions.find('[data-subaccordion]').hide().removeAttr('data--hidden');
      $accordions.find('[data-accordion-title]').removeClass('is-open');

      const $firstAccordion = $accordions.eq(0);
      $firstAccordion.find('[data-accordion-title]').addClass('is-open');
      $firstAccordion.find('[data-subaccordion]').show();
      return;
    }

    $scope.find('[data-accordion]').each(function() {
      const $accordion = $(this);
      const $title = $accordion.find('h2.faq-item__title span').first().text().toLowerCase();
      const titleMatches = $title.includes(query);
      let hasVisibleSubitems = false;

      $accordion.find('[data-subaccordion]').each(function() {
        const $subitem = $(this);
        const $subtitle = $subitem.find('.faq-item__subtitle span').first().text().toLowerCase();
        const allTermsMatch = titleMatches || searchTerms.every(term => $subtitle.includes(term));

        if (allTermsMatch) {
          hasVisibleSubitems = true;
          $subitem.removeAttr('data--hidden').show();
        } else {
          $subitem.attr('data--hidden', 'true').hide();
        }
      });

      if (titleMatches || hasVisibleSubitems) {
        $accordion.removeAttr('data--hidden').show();
        $accordion.find('[data-accordion-title]').addClass('is-open');
      } else {
        $accordion.attr('data--hidden', 'true').hide();
        $accordion.find('[data-accordion-title]').removeClass('is-open');
      }
    });
  }

  // Trigger search overlay
  $('[data-show-search-trigger]').on('click', function() {
    var display_mode = $(this).data('search-style');
    if (display_mode === "overlay") {
      $('[data-overlay-search]').toggleClass('is_active');
      $("[data-popup='search-popup']").addClass('is-hidden');
      $('[data-faq-search]').first().trigger('focus');
    }
  });

  // Search button click event
  $('[data-faq-search-btn]').on('click', function() {
    const $scope = getScope($(this));
    const search_q = $scope.find('[data-faq-search]').first().val() || '';
    filterFAQs(search_q, $scope);
  });

  // Search input keypress event (Enter key)
  $('[data-faq-search]').on('keydown', function(evt) {
    if (evt.key === 'Enter') {
      const $scope = getScope($(this));
      const search_q = $(this).val() || '';
      filterFAQs(search_q, $scope);
    }
  });

  // Close search
  $('.search-close').on('click', function() {
    const $scope = getScope($(this));
    $scope.find('[data-faq-search]').val('').attr('placeholder', 'Search FAQs...');
    filterFAQs('', $scope);
    $scope.find('[data-accordion]').removeAttr('data--hidden').show();
    $scope.find('[data-subaccordion]').hide();
    $scope.find('[data-accordion-title]').removeClass('is-open');

    const $firstAccordion = $scope.find('.faq-item.accordion').eq(0);
    $firstAccordion.removeAttr('data--hidden').show();
    $firstAccordion.find('[data-accordion-title]').addClass('is-open');
    $firstAccordion.find('[data-subaccordion]').show();
  });

}
